import styled from 'styled-components';

// Styles the form
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  width: 100%;

  ${({ theme }) => theme.media.tabletPortraitUp`
    input[type="submit"] {
      width: 100%;
    }
  `}
`;

// Contains all inputs in a form
export const InputContainer = styled.fieldset`
  box-sizing: border-box;
  margin-bottom: 20px;

  & > *:not(:last-child) {
    margin-bottom: 15px;
  }
`;

// Wrapper for password input with visibility toggle
export const PasswordFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    flex: 1;
    padding-right: 30px;
  }

  button {
    position: absolute;
    right: 10px;
    top: 50%;
    bottom: 0;
    margin: auto;
    background: none;
    border: none;
    cursor: pointer;
    transform: translateY(-50%);

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
